<template>
  <div class="head-tabs">
    <div class="t_tab-logo"><span class="webname">{{webinfo}}</span></div>
    <div class="t_btn-list clearBoth" v-if="activeTabs.length">
      <button
        class="t_btn-item t_tab-btn t_btn-d"
        @click="onTab(activeTabs[index].path,activeTabs[index].lottery_type)"
        v-for="(i, index) in (activeTabs.length > 8 ? 8 : activeTabs.length)"
        :key="'tab' + index"
        :class="{'router-link-active':computedActive(activeTabs[index])}"
      >
        <span>{{activeTabs[index].top}}</span>
        <span>{{activeTabs[index].b}}</span>
      </button>
    </div>

    <div class="fixed-right">
      <div
        class="button t_btn-item t_tab-btn t_btn-d game"
        :class="{active: dragList}"
        @click="showDragList"
      >
        <p>全部</p>
        <p>游戏</p>

        <div v-show="dragList" class="game-drag t_btn-h-bc" :style="contentStyleObj">
          拖动进行排序
          <drag-list
            @sort-move="onMove"
            @sort-start="onStart"
            @sort-end="onSortEnd"
            :value="tabMap"
            helperClass="dragging"
            class="game-list"
          >
            <drag-item
              class="game-item tc-b_h"
              :class="[`theme_${theme}`, {'t_b-c': route.indexOf(drag.path) > -1}]"
              v-for="(drag, ind) in tabMap"
              :index="ind"
              :item="drag"
              :key="'dr' + ind"
            >
              {{ind + 1}}. {{drag.title}}
              <div
                data-prevent="stop"
                class="checkbox"
                v-if="drag.lottery_type == $route.query.lottery_type"
                :class="{selected: drag.active}"
              ></div>
            </drag-item>
          </drag-list>
        </div>
      </div>
      <!--皮肤切换隐藏-->
      <!--<div tag="button" class="t_tab-btn t_c-theme">
        <span class="theme-span theme-1" @click="changeTheme(3)"></span>
        <span class="theme-span theme-2" @click="changeTheme(2)"></span>
        <span class="theme-span theme-3" @click="changeTheme(1)"></span>
      </div>-->

      <event tag="button" @click.prevent="logoutApp" class="t_tab-btn t_tab-logout"></event>
    </div>

    <div class="mask tab-mask" v-if="dragList" @click.self="hideDragList"></div>
  </div>
</template>

<style scoped lang="stylus">
@media screen and (max-width: 600px) {
  .t_tab-logo{width:10vw !important} 
  .webname{padding-left:5vw !important;font-size:0.8rem !important}
  .head-tabs{padding-left:20vw !important;}
  .t_btn-item{width:50px !important;}
  .t_btn-list {float: left !important;}
  .fixed-right{margin-left: 20px !important;
    float: left !important;
    position: relative !important;}
}
  .dragging {
  z-index: 1000 !important;
  padding-left: 10px;
}

.t_b-c {
  color: #fff !important;
}

.t_b-c:hover {
  color: #ffffff !important;
}

.webname {
  font-family: '微软雅黑';
  padding-left: 58px;
  line-height: 40px;
  font-size: 32px;
  letter-spacing: 6px;
  font-weight:bold;
}

.theme_1 {
  &.t_b-c {
    background-color: #ff9900;
  }
}

.theme-1 .t_tab-logo .webname {
  color: #FFFFE0;//#ff9900
}

.theme_2 {
  &.t_b-c {
    background-color: #28B32A;
  }
}

.theme-2 .t_tab-logo .webname {
  color: #FFD700;//#1eab26
}

.theme_3 {
  &.t_b-c {
    background-color: #9551CA;
  }
}

.theme-3 .t_tab-logo .webname {
  color: #0afae4//#9551CA
}
</style>
<style scoped lang="stylus">
$height = 40px;

.tab-mask {
}

.game-drag::-webkit-scrollbar {
  width: 2px;
}

.head-tabs {
  height: 44px;
  position: relative;
  box-sizing: border-box;
  padding-left: 215px;
  padding-right: 270px;
  white-space: nowrap;

  &:before {
    width: 0;
    height: 100%;
    display: inline-block;
    content: '';
    vertical-align: middle;
  }

  .t_tab-btn {
    height: $height;
    line-height: 20px;
    margin-left: 13px;
    background: linear-gradient(#fff,#e6e6e6);
    border:1px solid #fff;
  }

  > .t_tab-logo {
    top: 66%;
    left: 0;
    width: 163px;
    height: 44px;
    position: absolute;
    margin-top: -30px;
    background: url('/static/logo.png') no-repeat center center;
    background-size: contain;
  }

  > .t_btn-list {
    display: inline-block;
    vertical-align: middle;

    &:after {
      display: inline-block;
      content: '';
      width: 0;
      height: 100%;
      vertical-align: middle;
    }

    > .t_btn-item {
      width: 86px;
      margin-left: 10px;
      margin-top:3px;
      border-radius: 3PX;
      height: $height;
      display: inline-block;

      span {
        display: block;
      }
    }
  }

  > .fixed-right {
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    position: absolute;
    height: 100%;

    > .game {
      width: 80px;
      position: relative;
      font-size: 14px;
      box-sizing: border-box;

      .game-drag {
        top: 60px;
        left: -10px;
        color: #666;
        width: 200px;
        z-index: 101;
        position: absolute;
        border-width: 1px;
        border-style: solid;
        border-radius: 4px;
        background-color: #f0f0f0;
        max-height: 738px;
        overflow-y: auto;

        &:before, &:after {
          left: 40px;
          z-index: 11;
          content: '';
          display: block;
          position: absolute;
          border-style: solid;
          border-color: transparent;
          border-width: 6px;
        }

        &:before {
          top: -12px;
          border-bottom-color: inherit;
        }

        &:after {
          top: -11px;
          border-bottom-color: #ffffff;
        }

        .game-item {
          padding: 0 10px;
          text-align: left;
          position: relative;
          padding-right: 30px;
          box-sizing: border-box;

          .checkbox {
            width: 16px;
            height: 16px;
            position: absolute;
            right: 10px;
            top: 50%;
            z-index: 100;
            margin-top: -8px;
            border-radius: 8px;
            background-color: #e6e6e6;

            &:after {
              top: 50%;
              left: 50%;
              width: 10px;
              height: 10px;
              content: '';
              display: block;
              margin-top: -5px;
              margin-left: -5px;
              border-radius: 5px;
              position: absolute;
              transition: all 0.2s linear;
            }
          }

          .selected {
            border: 1px solid orangered;
            box-sizing: border-box;

            &:after {
              background-color: orangered;
            }
          }
        }
      }
    }

    > .t_c-theme {
      width: 100px;
      height: $height;
      font-size: 0;
      vertical-align: middle;
      text-align: center;
      border: 1px solid #aaaaaa;
      background: linear-gradient(#fff,#e6e6e6);
      border-radius: 2px;

      &:after {
        content: '';
        width: 0;
        height: 100%;
        display: inline-block;
        vertical-align: middle;
      }

      .theme-span {
        width: 12px;
        height: 12px;
        margin: 0 6px 0 6px;
        display: inline-block;
        border-radius: 6px;
        vertical-align: middle;
        background-color: orange;
      }

      .theme-1 {
        background: linear-gradient(#733DB4, #9551CA);
      }

      .theme-2 {
        background: linear-gradient(#05971E, #28B32A);
      }

      .theme-3 {
        background: linear-gradient(#FF9900, #FF6600);
      }
    }

    > .t_tab-logout {
      width: $height;
      height: $height;
      background: url('./images/logout.png') no-repeat center center;
      border-radius: 50%;
      border: 1px solid #aaaaaa;
      background-size: contain;
    }
  }

  .t_btn-item-active {
    color: #fff;
    border-color: #FFF;
  }
}
  .theme-1 .t_btn-item-active
  {
    background: linear-gradient(#FF9900, #FF6600) !important
  }
  .theme-2 .t_btn-item-active
  {
    background: linear-gradient(#28b32a, #05971e) !important;
  }
  .theme-3 .t_btn-item-active
  {
    background: linear-gradient(#9551ca, #733db4) !important
  }
</style>
<script>
  import { getWebInfo } from '@/service/user'
  import { mapActions, mapGetters } from "vuex";
  import DragList from "../../c_drag/DragList";
  import DragItem from "../../c_drag/DragItem";
  import {
    setLocalLotteryType,
    getLocalLotteryType
  } from "../../../utils/localStorageService";
  import Vue from "../../../utils/bus"

  export default {
    name: "index",
    components: {
      DragList,
      DragItem
    },
    props: {
      changeTheme: {
        type: Function,
        default() {
          return () => {
          };
        }
      }
    },
    data() {
      return {
        curPage: 0,
        dragList: false,
        tabMap: [],
        route: "",
        webinfo: "",
        contentStyleObj: {
          height: ''
        }

      };
    },
    watch: {
      tabsLen: {
        handler() {
          this.tabMap = this.headTabs || [];
        },
        immediate: true
      },
      $route: {
        handler(route) {
          this.route = route.path;
        },
        immediate: true
      }
    },
    computed: {
      ...mapGetters("root", ["theme"]),
      ...mapGetters("home", ["headTabs"]),
      activeTabs() {
        const DEFAULT_TABS = this.headTabs.filter(tab => tab.active);
        return DEFAULT_TABS;
      },
      tabsLen() {
        return this.headTabs.length;
      }
    },
    methods: {
      ...mapActions("root", ["logout"]),
      ...mapActions("home", ["setHeadTabs"]),
      computedActive(item) {
        return item.lottery_type == this.$route.query.lottery_type;
      },
      onTab(url,lotteryType) {
        if(lotteryType==18)
          this.changeTheme(2);
        else if(lotteryType==17)
          this.changeTheme(3);
        else if(lotteryType==16)
          this.changeTheme(1);
        this.$store.state.inputnum = "";

        this.$router.push(url + "&index=0");
        setTimeout(() => {
          Vue.$emit("onChangeTab");
        }, 500)

      },
      logoutApp() {
         this.$store.dispatch("home_PK10/setPlayedName", '');
            this.logout().then(res => {
          if (res) {
            this.$Message.success("登出成功");
            const path = encodeURIComponent(location.pathname + location.search);
            this.$router.replace(`/login?path=${path}`);
          }
        });
      },
      onStart() {
        this.is_moving = false;
      },
      onMove() {
        this.is_moving = true;
      },
      onSortEnd(el) {
        if (!this.is_moving) {
          const c = this.tabMap[el.newIndex];
          if (c.lottery_type === this.$route.query.lottery_type) return;

          const lottery_types = {
            1: "gd_ha10",
            2: "cc_ssc",
            3: "pk10",
            4: 'lh',
            5: 'fantan',
          };

          this.$router.push({
            path: `/home/${lottery_types[c.category]}`,
            query: {
              lottery_type: c.lottery_type,
              category_id: c.category
            }
          });

          this.hideDragList();
          return;
        }

        if (el.newIndex === el.oldIndex) return;

        const _item = this.tabMap.splice(el.oldIndex, 1);

        this.tabMap.splice(el.newIndex, 0, ..._item);
        // 把最新的排序存储到本地缓存
        setLocalLotteryType(this.tabMap);
        const type = getLocalLotteryType();
        this.setHeadTabs(this.tabMap);
      },

      changeActive(e, drag) {
        e.preventDefault();
        drag.active = !drag.active;
      },

      showDragList() {
        this.dragList = true;
      },

      hideDragList() {
        this.dragList = false;
      },
      getHeight() {
        this.contentStyleObj.height = window.innerHeight - 100 + 'px';
      },
      async getWebinfo() {
        this.webinfo = await getWebInfo();
      }
    },

    created() {
      window.addEventListener('resize', this.getHeight);
      this.getHeight();
      this.getWebinfo();

    },
    destroyed() {
      window.removeEventListener('resize', this.getHeight)
    },

  };

</script>



// WEBPACK FOOTER //
// src/components/common/headTabs/index.vue